import { contactCardsResolver } from '@resolvers/contact-cards.resolver';
import { strapiResolver } from '@resolvers/strapi.resolver';

export const Landingpages = [
  {
    id: 'homepage',
    url: { cs: '' },
    loadComponent: () => import('@pages/strapi/homepage/homepage.component').then(m => m.HomepagePageComponent),
    resolve: {
      data: strapiResolver
    },
    data: { page: 'homepage' },
  },
  {
    id: 'sellCar',
    url: { cs: 'prodat' },
    loadComponent: () => import('@pages/strapi/sell-car/sell-car.component').then(m => m.SellCarPageComponent),
    resolve: {
      data: strapiResolver
    },
    data: { page: 'sell' },
  },
  {
    id: 'services',
    url: { cs: 'sluzby' },
    loadComponent: () => import('@pages/strapi/services/services.component').then(m => m.ServicesPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'service' },
  },
  {
    id: 'contact',
    url: { cs: 'kontakt' },
    loadComponent: () => import('@pages/strapi/contact/contact.component').then(m => m.ContactPageComponent),
    resolve: {
      data: strapiResolver,
      contactCards: contactCardsResolver,
    },
    data: { page: 'contact' },
  },
  {
    id: 'aboutCompany',
    url: { cs: 'o-spolecnosti' },
    loadComponent: () => import('@pages/strapi/about-company/about-company.component').then(m => m.AboutCompanyPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'about-us' },
  },
  {
    id: 'complaint',
    url: { cs: 'reklamace' },
    loadComponent: () => import('@pages/strapi/complaint/complaint.component').then(m => m.ComplaintPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'complaint' },
  },
  {
    id: 'cookies',
    url: { cs: 'cookies' },
    loadComponent: () => import('@pages/strapi/cookies/cookies.component').then(m => m.CookiesPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'cookies' },
  },
  {
    id: 'priceList',
    url: { cs: 'cenik' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/price-list/price-list.component').then(m => m.PriceListPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'price-list' },
  },
  {
    id: 'gdpr',
    url: { cs: 'zasady-zpracovani-a-ochrany-osobnich-udaju' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/gdpr/gdpr.component').then(m => m.GdprPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'gdpr-terms' },
  },
  {
    id: 'gdprForm',
    url: { cs: 'gdpr-kontaktni-formular' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/gdpr-form/gdpr-form.component').then(m => m.GdprFormPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'gdpr-form' },
  },
  {
    id: 'dataProtectionOfficer',
    url: { cs: 'dpo-informace' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/data-protection-officer/data-protection-officer.component').then(m => m.DataProtectionOfficerPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'gdpr-data-protection-officer' },
  },
  {
    id: 'downloads',
    url: { cs: 'dokumenty-ke-stazeni' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/downloads/downloads.component').then(m => m.DownloadsPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'gdpr-documents' },
  },
  {
    id: 'representativeExamples',
    url: { cs: 'reprezentativni-priklady' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/representative-examples/representative-examples.component').then(m => m.RepresentativeExamplesPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'consumers-info-representative-examples' },
  },
  {
    id: 'consumerDisputes',
    url: { cs: 'spotrebitelske-spory' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/consumer-disputes/consumer-disputes.component').then(m => m.ConsumerDisputesPageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'consumer-info-consumer-disputes' },
  },
  {
    id: 'termsOfUse',
    url: { cs: 'podminky-uziti-stranek' },
    type: 'conditions',
    loadComponent: () => import('@pages/strapi/term-of-use/term-of-use.component').then(m => m.TermOfUsePageComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'consumer-info-terms-of-use' },
  },
  {
    id: 'requiredDocuments',
    url: { cs: 'potrebne-doklady-k-prodeji-vozu' },
    loadComponent: () => import('@pages/strapi/required-documents/required-documents.component').then(m => m.RequiredDocumentsComponent),
    resolve: {
      data: strapiResolver,
    },
    data: { page: 'required-documents' },
  },
];
